import { groupedPaymentActions } from '../config/actions';

const defaultState = {
  isLoading: null,
  data: [],
  error: null,
  filter: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case groupedPaymentActions.GROUPED_PAYMENT_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || [],
        error: null,
        filter: state.filter
      };
    case groupedPaymentActions.GROUPED_PAYMENT_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        error: action.error,
        filter: state.filter
      };
    case groupedPaymentActions.GROUPED_PAYMENT:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        error: null,
        filter: action.filter || state.filter
      };
    default:
      return state;
  }
};
